module.exports = __webpack_public_path__ + "img/search-photo-1.87cba17d.png";